import { BaseApiService } from '@services/baseApiService';
import { DocumentOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class DocumentService extends BaseApiService<DocumentOutputDTO> {
  constructor() {
    super('documents');
  }

  async create(data: Partial<DocumentOutputDTO>): Promise<ApiResponse<DocumentOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const documentData = {
      ...data,
    };
    
    return await super.create(documentData);
  }

  async update(id: string, data: Partial<DocumentOutputDTO>): Promise<ApiResponse<DocumentOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const documentData = {
      ...data,
    };
    
    return await super.update(id, documentData);
  }

  // You can add document-specific methods here if needed
}

export const documentService = new DocumentService(); 